module.exports = __webpack_public_path__ + "img/6.a5ce7d49.jpg";